const flashNotice = document.querySelector("#flash-notice")
if (flashNotice) {
  document.querySelector("#close-flash").addEventListener("click", function(e) {
    e.target.parentNode.style.display = "none"
  })
}
